import { VisualShape, VisualZoom } from 'app/frontend/types/custom/VisualPlan'
import { isIconShape } from '../shapes/iconShapes'

type Props = {
  shapes: VisualShape[]
  canvasWidth: number
  canvasHeight: number
  zoom: VisualZoom | undefined
}

const AbilityWowheadOverlay = ({
  shapes,
  canvasWidth,
  canvasHeight,
  zoom,
}: Props) => {
  const scale = zoom && zoom.scale > 1 ? zoom.scale : 1
  const stageX = zoom && scale > 1 ? -zoom.x * canvasWidth * (scale - 1) : 0
  const stageY = zoom && scale > 1 ? -zoom.y * canvasHeight * (scale - 1) : 0

  const abilityShapes = shapes.filter(
    (shape): shape is Extract<VisualShape, { type: 'icon' }> =>
      isIconShape(shape) && shape.kind === 'ability',
  )

  if (abilityShapes.length === 0) return null

  return (
    <div className='pointer-events-none absolute inset-0 z-10'>
      {abilityShapes.map((shape) => {
        const pixelWidth = shape.width * canvasWidth
        const pixelHeight = shape.height * canvasHeight
        const centerX = shape.x * canvasWidth
        const centerY = shape.y * canvasHeight
        const left = (centerX - pixelWidth / 2) * scale + stageX
        const top = (centerY - pixelHeight / 2) * scale + stageY

        return (
          <a
            key={shape.id}
            href={`https://wowhead.com/spell=${shape.value}`}
            target='_blank'
            rel='noreferrer'
            className='pointer-events-auto absolute'
            style={{
              left,
              top,
              width: pixelWidth * scale,
              height: pixelHeight * scale,
              transform: shape.rotation
                ? `rotate(${shape.rotation}deg)`
                : undefined,
              transformOrigin: 'center center',
            }}
            aria-label={shape.name ?? shape.value}
          />
        )
      })}
    </div>
  )
}

export default AbilityWowheadOverlay
